import { MessageCircle } from "lucide-react";
import { WA_DEFAULT_MSG, waLink } from "@/lib/data";
import { useLang } from "@/lib/i18n";

const WhatsAppFab = () => {
    const { tr } = useLang();
    return (
        <a
            data-testid="whatsapp-fab"
            href={waLink(tr(WA_DEFAULT_MSG))}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
            className="fixed bottom-5 right-5 md:bottom-7 md:right-7 z-50 group"
        >
            <span className="absolute inset-0 rounded-full bg-whatsapp animate-pulse-ring" />
            <span className="relative flex h-14 w-14 md:h-16 md:w-16 items-center justify-center rounded-full bg-whatsapp text-white shadow-[0_10px_30px_rgba(37,211,102,0.35)] transition-transform duration-300 group-hover:scale-110">
                <MessageCircle className="h-7 w-7 md:h-8 md:w-8" strokeWidth={2.2} />
            </span>
            <span className="pointer-events-none absolute right-full mr-4 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-obsidian-surface border border-white/10 px-4 py-2 text-sm text-cream opacity-0 transition-opacity duration-300 group-hover:opacity-100 hidden md:block">
                {tr("Discute avec moi sur WhatsApp", "Chat with me on WhatsApp")}
            </span>
        </a>
    );
};

export default WhatsAppFab;
